export const SETTINGS_PARAM = "settings";

export const SETTINGS_SECTION_IDS = [
  "profile",
  "security",
  "notifications",
  "privacy",
  "company",
  "team",
  "locations",
  "documents",
  "invoices",
  "payouts",
  "freight-payments",
  "plan",
  "plans",
  "payment-methods",
  "payment-terms",
  "api",
] as const;

export type SettingsSectionId = (typeof SETTINGS_SECTION_IDS)[number];

export function settingsHref(
  section: SettingsSectionId,
  basePath = "/dashboard",
  extraParams?: Record<string, string | undefined>,
): string {
  const params = new URLSearchParams({ [SETTINGS_PARAM]: section });
  for (const [key, value] of Object.entries(extraParams ?? {})) {
    if (value !== undefined) params.set(key, value);
  }
  return `${basePath}?${params.toString()}`;
}
